<script lang="ts">
  import type { Detail, Bill } from '../../repositories/hatneohama';

  // 前画面から値を取得
  export let bill: Bill;
  export let details: Detail[];

  function displayDate(date: string) {
    return date.slice(0, 4) + '年' + date.slice(4, 6) + '月';
  }
</script>

<div class="h-auto p-6 bg-white w-full m-auto">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">請求金額の確認</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 p-8">
    <div class="flex flex-col">
      <div class="flex-auto mb-8 justify-content-start items-center">
        <h3 class="text-xl font-bold">
          {displayDate(bill.billYm)}の請求内容
          {#if bill.keyContract}
            （契約キー：{bill.keyContract}）
          {/if}
        </h3>
      </div>
      <div class="flex-auto mb-4 justify-content-start items-center">
        <div class="box-border h-1/7 w-1/3 border-gray-700 border p-4">
          <div class="inline-grid grid-cols-2 items-center min-w-full">
            <div class="grid-1 place-self-start">請求金額</div>
            <div class="grid-1 place-self-end">
              <span class="tabular-nums">
                {bill.amount.toLocaleString('ja-JP')}円
              </span>
            </div>
            <div class="grid-1 place-self-start">税額</div>
            <div class="grid-1 place-self-end">
              <span class="tabular-nums">
                {bill.tax.toLocaleString('ja-JP')}円
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-auto justify-content-start items-center">
        <div class="shadow overflow-hidden border-gray-200">
          <table class="min-w-full border-collapse border border-gray-800">
            <thead class="bg-gray-100">
              <tr>
                <th class="w-4/6" colspan="2">料金内訳</th>
                <th class="w-1/6">金額</th>
                <th class="w-1/6">税額</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <!-- 対象年月の一覧を取得して全て表示-->
              {#each details as detail}
                <tr>
                  <td>{detail.serviceName}</td>
                  <td>{displayDate(detail.useym)}</td>
                  <td>
                    <span class="tabular-nums">
                      {detail.amount.toLocaleString('ja-JP')}円
                    </span>
                  </td>
                  <td>
                    <span class="tabular-nums">
                      {detail.tax.toLocaleString('ja-JP')}円
                    </span>
                  </td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  thead tr th {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 leading-4;
  }
</style>
